<template>
  <div class="row">
    <div class="col-xs-12 col-md-12">
      <card :header-text="`${this.title ? this.title : 'Tus Inspirados'} (${totalRecords})`">
        <template v-slot:card-header>
          <router-link v-if="userToken" class="btn btn-action btn-small btn-success"
            :to="{ name: 'crear-inspirados', query: { key: userToken}}"
          >
            <i class="fa fa-plus"></i>&nbsp;<span>Crear</span>
          </router-link>
          <router-link v-else class="btn btn-action btn-small btn-success"
            :to="{ name: 'crear-inspirados'}"
          >
            <i class="fa fa-plus"></i>&nbsp;<span>Crear</span>
          </router-link>
        </template>
        <div class="row">
          <div class="col-md-6">
            <label for="numeroIdentidad" class="input-group input-group-sm mb-3">
                <small class="mr-3 align-self-center">CC/TI/NUIP/RC</small>
              <input id="numeroIdentidad" type="number" class="form-control" v-model.number="queryParams.filters.numeroIdentificacion">
              <div class="input-group-append" id="button-addon4">
                <button class="btn btn-small btn-outline-secondary"
                  @click="queryParams.filters.numeroIdentificacion ? cargarInspirados() : null"
                >
                  Buscar
                </button>
                <button
                  class="btn btn-small btn-outline-secondary"
                  type="button"
                  @click="queryParams.filters.numeroIdentificacion = ''; cargarInspirados()"
                >
                  Limpiar
                </button>
              </div>
            </label>
          </div>
          <div class="col-md-6">
            <label for="correo" class="input-group input-group-sm mb-3">
                <small class="mr-3 align-self-center">Email</small>
              <input id="correo" type="text" class="form-control" v-model.number="queryParams.filters.correo">
              <div class="input-group-append" id="button-addon4">
                <button class="btn btn-small btn-outline-secondary"
                  type="button"
                  @click="queryParams.filters.correo ? cargarInspirados() : null"
                >
                  Buscar
                </button>
                <button
                  class="btn btn-small btn-outline-secondary"
                  type="button"
                    @click="queryParams.filters.correo = ''; cargarInspirados()"
                >
                  Limpiar
                </button>
              </div>
            </label>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <td>Identificación</td>
                <td>Nombres</td>
                <td>Apellidos</td>
                <td>Teléfono</td>
                <td>Dirección</td>
                <td>Departamento</td>
                <td>Municipio</td>
                <td>N° Historias</td>
                <td align="center">Acciones</td>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="(inspirado, key) in inspirados" :key="key">
                <td>{{ inspirado.doc.numeroIdentificacion }}</td>
                <td>{{ inspirado.doc.nombres }}</td>
                <td>{{ inspirado.doc.apellidos }}</td>
                <td>{{ inspirado.doc.telefono }}</td>
                <td>{{ inspirado.doc.direccion }}</td>
                <td>{{ inspirado.doc.departamento.nombre }}</td>
                <td>{{ inspirado.doc.municipio.nombre }}</td>
                <td>{{ inspirado.doc.historias ? inspirado.doc.historias.length : 0  }}</td>
                <td align="center">
                  <router-link class="btn btn-small btn-action btn-info"
                    :to="{ name: 'ver-inspirado', params: {id: inspirado.id}}"
                    title="Ver"
                  >
                    <i class="fa fa-eye"></i>
                  </router-link>
                  <router-link v-if="!userToken" class="btn btn-small btn-action btn-warning"
                    :to="{ name: 'editar-inspirado', params: {id: inspirado.id}}"
                    title="Editar"
                  >
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <router-link v-else class="btn btn-small btn-action btn-warning"
                    :to="{ name: 'editar-inspirado', params: {id: inspirado.id}, query: { key: userToken}}"
                    title="Editar"
                  >
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <router-link v-if="!userToken"  class="btn btn-small btn-action btn-success"
                    :to="{ name: 'crear-historia', params: {id: inspirado.id}}"
                    title="Agregar Historia"
                  >
                    <i class="fa fa-magic"></i>
                  </router-link>
                  <button
                    v-if="user.rol === 'admin'"
                    @click="eliminarInspirado(inspirado.id)"
                    class="btn btn-small btn-danger"
                    title="Eliminar"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <paginate
              :pageCount="pageCount"
              :clickHandler="handlerPaginate"
              :prevText="'Anterior'"
              :nextText="'Siguiente'"
              :containerClass="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
            >
          </paginate>
        </div>
      </card>
    </div>
  </div>
</template>
<script>

import { obtenerInspirados } from '../../api/admin'
import apiInspirados from '../../api/inspirados'
import { getUserInfo } from '../../api/auth'
import { mapState } from 'vuex'
import paginate from 'vuejs-paginate'

export default {
  components: { paginate },
  props: {
    title: {
      type: String,
      default: ''
    },
    userToken: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inspirados: [],
      totalRecords: 0,
      queryParams: {
        page: 1,
        filters: {
          idInspirador: undefined
        }
      }
    }
  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    pageCount () {
      return Math.ceil(this.totalRecords / 20)
    }
  },
  watch: {
    userToken () {
      this.obtenerInspiradosActuales()
    }
  },
  async mounted () {
    if (this.user !== {}) await this.$store.dispatch('user/getUserInfo')
    this.obtenerInspiradosActuales()
  },
  methods: {
    async eliminarInspirado (idInspirado) {
      const res = confirm('¿Está seguro que desea eliminar el Inspirado seleccionado?')
      if (res) {
        await apiInspirados.eliminarInspirado(idInspirado)
        this.cargarInspirados()
        alert('Eliminado')
      }
    },
    obtenerInspiradosActuales () {
      let rol = ''
      try {
        rol = this.user.rol.toLowerCase()
      } catch (error) {
        return
      }

      if (!rol) return

      const token = (rol === 'merani' || rol === 'admin') ? this.userToken : this.token
      if (!token) return

      getUserInfo(token).then(doc => {
        this.queryParams.filters.idInspirador = token
        this.cargarInspirados()
      }).catch((err) => {
        console.error(err)
      })
    },
    async cargarInspirados () {
      const data = await obtenerInspirados(this.queryParams)
      this.inspirados = data.results
      this.totalRecords = data.total
      this.$forceUpdate()
    },
    handlerPaginate (page) {
      this.queryParams.page = page
      this.cargarInspirados()
    }
  }
}
</script>
<style lang="scss">
  .table thead tr{
    color: #007bff;
  }
  .error-icon{
    color: #e34a4a;
  }
  .success-icon {
    display: inline-block;
    color: #4ae387;
  }
  .table-sm th, .table-sm td{
    padding: .7rem;
  }
  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }
  .btn-small {
    font-size: 12px;
  }
  .btn-action {
    margin-right: 10px;
    padding: 4px 8px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (max-width: 992px) {
      span {
        display: none;
      }
    }
  }
</style>
